(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toth-itinerario"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('toth-itinerario')) {
    class TothItinerario extends HTMLElement {
      #timer = null;
      #io = null;
      #itens = [];
      #paineis = [];

      connectedCallback() {
        this.#itens = [...this.querySelectorAll('[data-item]')];
        this.#paineis = [...this.querySelectorAll('[data-painel]')];

        const hoverFino = matchMedia('(hover: hover) and (min-width: 990px)');

        for (const [i, item] of this.#itens.entries()) {
          const linha = item.querySelector('[data-linha]');
          if (!linha) continue;
          linha.addEventListener('click', () => this.#ativar(i, true));
          linha.addEventListener('pointerenter', () => {
            if (hoverFino.matches) this.#ativar(i, false);
          });
        }

        this.#relogio();
        this.#timer = setInterval(() => this.#relogio(), 30000);

        const semMovimento = matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!semMovimento && 'IntersectionObserver' in window) {
          this.classList.add('is-prep');
          this.#io = new IntersectionObserver((entradas) => {
            for (const e of entradas) {
              if (!e.isIntersecting) continue;
              this.classList.add('is-visto');
              this.#embaralhar();
              this.#io.disconnect();
              this.#io = null;
            }
          }, { threshold: 0.25 });
          this.#io.observe(this);
        }
      }

      disconnectedCallback() {
        clearInterval(this.#timer);
        this.#io?.disconnect();
      }

      #ativar(indice, clique) {
        for (const [j, item] of this.#itens.entries()) {
          const ativo = j === indice;
          item.classList.toggle('is-ativo', ativo);
          if (clique) {
            if (ativo) item.classList.toggle('is-aberto');
            else item.classList.remove('is-aberto');
          }
          item.querySelector('[data-linha]')
            ?.setAttribute('aria-expanded', String(item.classList.contains('is-aberto')));
        }
        for (const [j, painel] of this.#paineis.entries()) {
          painel.classList.toggle('is-ativo', j === indice);
        }
      }

      #relogio() {
        for (const el of this.querySelectorAll('[data-fuso]')) {
          try {
            el.textContent = new Intl.DateTimeFormat('pt-BR', {
              hour: '2-digit',
              minute: '2-digit',
              timeZone: el.dataset.fuso
            }).format(new Date());
          } catch {
            el.remove(); /* fuso inválido no editor: some sem quebrar nada */
          }
        }
      }

      #embaralhar() {
        const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let base = 0;
        const giraCelula = (celula, ch, atraso, duracao) => {
          setTimeout(() => {
            const giro = setInterval(() => {
              celula.textContent = CHARS[Math.floor(Math.random() * CHARS.length)];
            }, 42);
            setTimeout(() => {
              clearInterval(giro);
              celula.textContent = ch;
            }, duracao);
          }, atraso);
        };

        /* nome: o JS envolve caractere a caractere */
        for (const el of this.querySelectorAll('[data-flap]')) {
          const texto = el.textContent;
          el.setAttribute('aria-label', texto);
          const envelope = document.createElement('span');
          envelope.setAttribute('aria-hidden', 'true');

          for (const [idx, ch] of [...texto].entries()) {
            const celula = document.createElement('span');
            celula.className = 'titn__char';
            celula.textContent = ch;
            envelope.append(celula);
            if (!ch.trim()) continue;
            giraCelula(celula, ch, base + idx * 30, 260 + idx * 42);
          }

          el.replaceChildren(envelope);
          base += 45;
        }
      }
    }
    customElements.define('toth-itinerario', TothItinerario);
  }

  } catch(e) { console.error(e); }
})();
})();
